const ToggleBtn = ({ isChecked, setIsChecked }) => {
  return (
    <label className="switch">
      <input type="checkbox" checked={isChecked} onChange={setIsChecked} />
      <span className="slider"></span>
    </label>
  );
};
export default ToggleBtn;
